module.exports = __webpack_public_path__ + "img/paisajeregisterdesktop.b40ed813.jpg";